module.exports = __webpack_public_path__ + "static/img/nu.433deb3d.svg";